/**
 * リザルトに着いたら1セッションぶんの取り組みを記録する(docs/14_characters.md §2)。
 *
 * 置き場所がリザルト画面なのは、**どのモードでも「リザルトに着いた = 1回あそんだ」**が
 * 共通の区切りだから(ストアごとに書き足すと、モードが増えるたびに漏れる)。
 * 記録するのは領域と回数だけで、点数も時間も持たない。
 */

import { useEffect, useRef } from 'react';
import { activityRecorder, type ActivityDomain } from '../services/activityLog';

/**
 * 画面に出ているあいだ1回だけ記録する。
 *
 * `domain` が `null`(知らない教科など)のときは何もしない。
 * `useRef` のガードは **StrictMode の二重 effect よけ**
 * (開発時は mount → unmount → mount と走るが、ref は同じインスタンスで保たれる)。
 */
export function useRecordActivity(domain: ActivityDomain | null): void {
  const recorded = useRef(false);

  useEffect(() => {
    if (domain === null || recorded.current) return;
    recorded.current = true;
    activityRecorder.record(domain);
  }, [domain]);
}
